import Backbone from '@polleverywhere/backbone'
import env from '@polleverywhere/core/lib/env'
import URI from 'urijs'

// Powerpoint presentation model that monitors the presentation API.
export class Monitor {
  constructor ({ user }) {
    this.user = user
    this.putState = this.putState.bind(this)
    this.start = this.start.bind(this)
  }

  // Send information about changed state to firehose subscribers
  putState (state) {
    const url = URI(env.get('api_url'))
      .segment(`api/presentations/${this.user.get('id')}/sync`)
      .toString()
    return Backbone.ajax({
      url,
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({ presentation: state }),
      type: 'PUT'
    })
  }

  start () {
    if (window.slideshow) {
      window.slideshow.on('update', this.putState.bind(this))
    } else {
      console.error('Please load from native app.')
    }
  }
}
